@if (institutionId > 0 && showModule) {
  <div id="submodule-orders2" class="cw-module-card">
    @if (!showOrderDetails) {
      <div>
        <!-- Header -->
        <div class="cw-flex-row">
          <h2>{{ 'GENERAL.ORDERS' | translate }}</h2>
          <!-- Toolbar -->
          @if (!showOrderDetails) {
            <phscw-toolbar
              componentIdentifier="institutions-orders2"
              [componentConnection]="$any(this)"
              [buttonAdd]="true"
              buttonAddTooltip="{{ 'MODULES.INSTITUTIONS.ORDERS.ADDNEW' | translate }}"
              printContent="submodule-orders">
            </phscw-toolbar>
          }
        </div>
        <!-- Grid um Aufträge der Einrichtung anzuzeigen -->
        @if (!showOrderDetails) {
          <phscw-grid
            #gridInstitutionsOrders2
            gridId="institutionsOrders2"
            [simpleGrid]="true"
            [gridData]="data"
            [gridColumns]="gridColumns"
            [gridDisplayedColumns]="gridDisplayedColumns">
          </phscw-grid>
        }
        <!-- Funktion um weitere Einträge zu laden -->
        @if (!showOrderDetails) {
          <phscw-grid-load-more
            gridId="institutionsOrders2"
            [enabled]="loadMoreEnabled"
            [visible]="loadMoreVisible"
            [gridPageCounter]="gridPage">
          </phscw-grid-load-more>
        }
      </div>
    }
    <!-- Auftragserfassung -->
    @if (showOrderDetails) {
      <div>
        <!-- Auftragserfassungsformular -->
        <phscw-order-form
          [institutionAndOrderId]="{orderId: orderId, institutionId: institutionId}"
          [editMode]="editMode"
          (changeShowOrderDetailsMode)="showOrderDetails = $event"
          (submitOrder)="loadData($event)">
        </phscw-order-form>
      </div>
    }
  </div>
}
